/* Joyful Neon — konfigurátor neonu.
 *
 * Cena i limity znaků vycházejí z konfigurace v sekci (data-config), která
 * kopíruje ceník původní aplikace. Do košíku posíláme variantu odpovídající
 * kombinaci velikost × počet řádků; text, font a barvu předáváme jako
 * vlastnosti položky, aby je výroba viděla v objednávce.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-jn-neon]');
  if (!root) return;

  var cfg = JSON.parse(root.getAttribute('data-config'));
  var variants = JSON.parse(root.getAttribute('data-variants'));
  var moneyFormat = root.getAttribute('data-money') || '{{amount}} Kč';

  var state = {
    text: cfg.defaultText || 'Ahoj',
    color: cfg.colors[0],
    font: cfg.fonts[0],
    size: cfg.sizes[3] || cfg.sizes[0],
    scene: (cfg.scenes || []).filter(function (s) { return s.id === cfg.defaultScene; })[0] ||
           (cfg.scenes && cfg.scenes[0]) || null,
    lit: true
  };

  var el = {
    stage: root.querySelector('[data-jn-stage]'),
    svgText: root.querySelector('[data-jn-svgtext]'),
    svgGlow: root.querySelector('[data-jn-svgglow]'),
    input: root.querySelector('[data-jn-text]'),
    hint: root.querySelector('[data-jn-hint]'),
    colors: root.querySelector('[data-jn-colors]'),
    fonts: root.querySelector('[data-jn-fonts]'),
    sizes: root.querySelector('[data-jn-sizes]'),
    price: root.querySelector('[data-jn-price]'),
    submit: root.querySelector('[data-jn-submit]'),
    error: root.querySelector('[data-jn-error]'),
    toggle: root.querySelector('[data-jn-toggle]'),
    scenes: root.querySelector('[data-jn-scenes]')
  };

  function lines() {
    return state.text.split('\n').filter(function (l) { return l.trim() !== ''; });
  }

  function longestLine() {
    return lines().reduce(function (m, l) { return Math.max(m, l.length); }, 0);
  }

  /* Shopify má několik zástupných symbolů podle nastavení obchodu
     (amount, amount_with_comma_separator, amount_no_decimals…). */
  function money(cents) {
    var n = cents / 100;
    return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/gi, function (token) {
      var decimals = /no_decimals/.test(token) ? 0 : 2;
      var s = n.toLocaleString('cs-CZ', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
      return /comma_separator/.test(token) ? s.replace(/ /g, ' ') : s;
    });
  }

  function priceFor(size, lineCount) {
    var key = String(Math.max(1, lineCount));
    return size.price[key] != null ? size.price[key] : null;
  }

  /* Velikost umí daný text jen tehdy, když sedí počet řádků i délka řádku. */
  function sizeFits(size) {
    var n = Math.max(1, lines().length);
    return n <= size.maxLines && longestLine() <= size.maxChars && priceFor(size, n) != null;
  }

  function findVariant() {
    var n = Math.max(1, lines().length);
    var want = state.size.label + ' / ' + (n === 1 ? '1 řádek' : n + ' řádky');
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].title === want) return variants[i];
    }
    return null;
  }

  var svgEl = root.querySelector('.jn-neon__svg');

  /* Fotky se kreslí přes background-size: cover, takže při užší ploše se
     ořežou po stranách a je vidět méně centimetrů, než kolik měří záběr.
     Bez téhle korekce by byl neon v úzkém sloupci menší, než ve skutečnosti. */
  var sceneRatio = {};

  function measureScene(url) {
    if (!url || sceneRatio[url] !== undefined) return;
    sceneRatio[url] = null;
    var img = new Image();
    img.onload = function () {
      if (img.naturalHeight) {
        sceneRatio[url] = img.naturalWidth / img.naturalHeight;
        fitToScale();
      }
    };
    img.src = url;
  }

  /* Náhled musí odpovídat skutečnosti: nápis široký 30 cm ve fotce se
     záběrem 240 cm má zabírat 12,5 % viditelné šířky, ne pořád stejnou plochu.
     Proto ořízneme viewBox přesně na text a šířku SVG nastavíme poměrem
     rozměr neonu / šířka záběru. */
  function fitToScale() {
    var frame = (state.scene && state.scene.frameCm) || 300;
    var bb;
    try { bb = el.svgText.getBBox(); } catch (e) { return; }
    if (!bb || !bb.width) return;

    var box = el.stage.getBoundingClientRect();
    var ratio = state.scene ? sceneRatio[state.scene.url] : null;
    /* Kolik pixelů zabírá celý záběr fotky, když se ořezává na výšku plochy. */
    var frameWidthPx = (ratio && box.height) ? Math.max(box.width, box.height * ratio) : box.width;
    var pct = state.size.widthCm / frame * (frameWidthPx / (box.width || 1)) * 100;

    /* Do viewBoxu se musí vejít i záře (zhruba 3× stdDeviation největšího
       rozostření), jinak ji hrana SVG ořízne a kolem nápisu je vidět
       obdélník. Šířku prvku proto zvětšíme ve stejném poměru — samotný
       text tak zůstane přesně na spočítaných procentech. */
    var glow = 80;
    var vbW = bb.width + glow * 2, vbH = bb.height + glow * 2;
    svgEl.setAttribute('viewBox',
      (bb.x - glow) + ' ' + (bb.y - glow) + ' ' + vbW + ' ' + vbH);
    svgEl.style.width = Math.max(5, Math.min(94, pct)) * (vbW / bb.width) + '%';
  }

  function renderPreview() {
    var ls = lines();
    if (!ls.length) ls = [''];
    var svgNS = 'http://www.w3.org/2000/svg';
    [el.svgText, el.svgGlow].forEach(function (node) {
      while (node.firstChild) node.removeChild(node.firstChild);
      ls.forEach(function (line, i) {
        var t = document.createElementNS(svgNS, 'tspan');
        t.setAttribute('x', '50%');
        t.setAttribute('dy', i === 0 ? (ls.length > 1 ? '-0.55em' : '0') : '1.1em');
        t.textContent = line;
        node.appendChild(t);
      });
      node.style.fontFamily = "'" + state.font.family + "', cursive";
    });
    if (state.scene) measureScene(state.scene.url);
    fitToScale();
    root.style.setProperty('--neon-color', state.color.hex);
    root.classList.toggle('is--off', !state.lit);
    root.classList.toggle('is--day', !state.lit);
    if (state.scene) el.stage.style.backgroundImage = 'url(' + state.scene.url + ')';
  }

  function renderPrice() {
    var n = Math.max(1, lines().length);
    var cents = priceFor(state.size, n);
    var v = findVariant();
    var problem = null;

    if (!state.text.trim()) problem = 'Napište text, který má neon svítit.';
    else if (n > state.size.maxLines) problem = state.size.label + ' zvládne maximálně ' + state.size.maxLines + ' řádek. Zkuste větší velikost.';
    else if (longestLine() > state.size.maxChars) problem = state.size.label + ' zvládne ' + state.size.maxChars + ' znaků na řádek — máte ' + longestLine() + '.';
    else if (!v || cents == null) problem = 'Tuhle kombinaci zatím nevyrábíme. Napište nám a domluvíme se.';

    el.price.textContent = cents != null ? money(cents) : '—';
    el.error.textContent = problem || '';
    el.submit.disabled = !!problem;
    el.input.classList.toggle('is--over', longestLine() > state.size.maxChars);
    el.hint.textContent = 'max ' + state.size.maxChars + ' znaků na řádek, ' +
      state.size.maxLines + (state.size.maxLines === 1 ? ' řádek' : ' řádky');
    return v;
  }

  function renderSizes() {
    [].forEach.call(el.sizes.children, function (btn) {
      var size = cfg.sizes.filter(function (s) { return s.id === btn.dataset.id; })[0];
      btn.disabled = !sizeFits(size);
      btn.setAttribute('aria-pressed', String(size.id === state.size.id));
    });
  }

  function update() {
    renderPreview();
    renderSizes();
    renderPrice();
  }


  /* ---- vykreslení náhledu do obrázku ----
   * Objednávka má nést i obrázek, ne jen parametry — výroba pak nemusí nic
   * dohledávat a zákazník vidí, co si objednal. Kreslíme do canvasu, protože
   * ten umí použít písmo už načtené ve stránce; SVG převedené na obrázek by
   * o něj přišlo. Rozměry i pozice kopírují náhled na stránce.
   */
  function drawNeon(ctx, W, H, frameWidthPx) {
    var ls = lines(); if (!ls.length) return;
    var frame = (state.scene && state.scene.frameCm) || 300;
    var targetW = state.size.widthCm / frame * frameWidthPx;

    /* Velikost písma odvodíme z nejširšího řádku, aby nápis vyšel na
       skutečnou šířku neonu. */
    var probe = 200;
    ctx.font = probe + "px '" + state.font.family + "', cursive";
    var widest = ls.reduce(function (m, l) { return Math.max(m, ctx.measureText(l).width); }, 0);
    if (!widest) return;
    var fs = probe * (targetW / widest);
    ctx.font = fs + "px '" + state.font.family + "', cursive";
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    var lh = fs * 1.1;
    var cy = H * 0.41 - (ls.length - 1) * lh / 2;

    if (state.lit) {
      ctx.shadowColor = state.color.hex;
      ctx.fillStyle = state.color.hex;
      /* Několik průchodů se stínem dá záři hloubku, poslední kreslí jádro. */
      [fs * 0.45, fs * 0.22, fs * 0.1].forEach(function (blur) {
        ctx.shadowBlur = blur;
        ls.forEach(function (l, i) { ctx.fillText(l, W / 2, cy + i * lh); });
      });
      ctx.shadowBlur = 0;
      ctx.fillStyle = '#fff';
      ctx.globalAlpha = 0.35;
      ls.forEach(function (l, i) { ctx.fillText(l, W / 2, cy + i * lh); });
      ctx.globalAlpha = 1;
    } else {
      ctx.shadowBlur = 0;
      ctx.fillStyle = '#d7d7dc';
      ls.forEach(function (l, i) { ctx.fillText(l, W / 2, cy + i * lh); });
    }
  }

  function renderPreviewImage(done) {
    var W = 1400, H = 1000;
    var c = document.createElement('canvas');
    c.width = W; c.height = H;
    var ctx = c.getContext('2d');

    function finish(frameWidthPx) {
      drawNeon(ctx, W, H, frameWidthPx);
      c.toBlob(function (b) { done(b); }, 'image/jpeg', 0.86);
    }

    if (!state.scene) { ctx.fillStyle = '#101014'; ctx.fillRect(0, 0, W, H); finish(W); return; }

    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      /* Stejný ořez jako background-size: cover. */
      var s = Math.max(W / img.width, H / img.height);
      var w = img.width * s, h = img.height * s;
      if (!state.lit) ctx.filter = 'brightness(1.75) saturate(.85)';
      ctx.drawImage(img, (W - w) / 2, (H - h) / 2, w, h);
      ctx.filter = 'none';
      finish(w);
    };
    img.onerror = function () { ctx.fillStyle = '#101014'; ctx.fillRect(0, 0, W, H); finish(W); };
    img.src = state.scene.url;
  }

  /* ---- ovládání ---- */

  el.input.addEventListener('input', function () {
    state.text = el.input.value;
    /* Když text přeroste zvolenou velikost, nabídneme nejbližší, která sedí. */
    if (!sizeFits(state.size)) {
      var fit = cfg.sizes.filter(sizeFits)[0];
      if (fit) state.size = fit;
    }
    update();
  });

  el.colors.addEventListener('click', function (e) {
    var b = e.target.closest('[data-id]'); if (!b) return;
    state.color = cfg.colors.filter(function (c) { return c.id === b.dataset.id; })[0];
    [].forEach.call(el.colors.children, function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    update();
  });

  el.fonts.addEventListener('click', function (e) {
    var b = e.target.closest('[data-id]'); if (!b) return;
    state.font = cfg.fonts.filter(function (f) { return f.id === b.dataset.id; })[0];
    [].forEach.call(el.fonts.children, function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    update();
  });

  el.sizes.addEventListener('click', function (e) {
    var b = e.target.closest('[data-id]'); if (!b || b.disabled) return;
    state.size = cfg.sizes.filter(function (s) { return s.id === b.dataset.id; })[0];
    update();
  });

  if (el.scenes) el.scenes.addEventListener('click', function (e) {
    var b = e.target.closest('[data-id]'); if (!b) return;
    state.scene = cfg.scenes.filter(function (s) { return s.id === b.dataset.id; })[0];
    [].forEach.call(el.scenes.children, function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    update();
  });

  el.toggle.addEventListener('click', function () {
    state.lit = !state.lit;
    el.toggle.setAttribute('aria-pressed', String(state.lit));
    el.toggle.textContent = state.lit ? 'Noc' : 'Den';
    update();
  });

  /* Diakritika v názvu souboru dělá potíže při stahování, proto přepis. */
  function slug(t) {
    return t.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-|-$/g, '').toLowerCase().slice(0, 40) || 'neon';
  }

  function designUrl() {
    return location.origin + location.pathname + '?' + new URLSearchParams({
      text: state.text, font: state.font.id, color: state.color.id,
      size: state.size.id, scene: state.scene ? state.scene.id : ''
    }).toString();
  }

  el.submit.addEventListener('click', function () {
    var v = renderPrice();
    if (!v) return;
    el.submit.disabled = true;
    var original = el.submit.textContent;
    el.submit.textContent = 'Přidávám…';

    function send(blob) {
      /* Soubor jde do košíku jako příloha položky — Shopify ho uloží a
         v objednávce z něj udělá odkaz. Proto multipart, ne JSON. */
      var fd = new FormData();
      fd.append('id', v.id);
      fd.append('quantity', '1');
      fd.append('properties[Text]', state.text);
      fd.append('properties[Font]', state.font.label);
      fd.append('properties[Barva]', state.color.label + ' (' + state.color.hex + ')');
      fd.append('properties[Velikost]', state.size.label + ' na délku');
      fd.append('properties[Počet řádků]', String(Math.max(1, lines().length)));
      fd.append('properties[Prostor v náhledu]', state.scene ? state.scene.label : '—');
      fd.append('properties[Odkaz na návrh]', designUrl());
      if (blob) fd.append('properties[Náhled]', blob, 'neon-' + slug(state.text) + '.jpg');

      fetch('/cart/add.js', { method: 'POST', body: fd }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        window.location.href = '/cart';
      }).catch(function () {
        el.submit.disabled = false;
        el.submit.textContent = original;
        el.error.textContent = 'Nepodařilo se přidat do košíku. Zkuste to prosím znovu.';
      });
    }

    /* Kdyby vykreslení selhalo, objednávka projde i bez obrázku — parametry
       a odkaz na návrh k výrobě stačí. */
    var done = false;
    var fallback = setTimeout(function () { if (!done) { done = true; send(null); } }, 6000);
    try {
      renderPreviewImage(function (blob) {
        if (done) return;
        done = true; clearTimeout(fallback); send(blob);
      });
    } catch (e) {
      if (!done) { done = true; clearTimeout(fallback); send(null); }
    }
  });

  /* Návrh se dá sdílet odkazem — a stejný odkaz slouží výrobě jako podklad. */
  (function restoreFromUrl() {
    var p = new URLSearchParams(location.search);
    if (p.get('text')) state.text = p.get('text');
    var byId = function (arr, id) { return arr.filter(function (x) { return x.id === id; })[0]; };
    state.font = byId(cfg.fonts, p.get('font')) || state.font;
    state.color = byId(cfg.colors, p.get('color')) || state.color;
    state.size = byId(cfg.sizes, p.get('size')) || state.size;
    state.scene = byId(cfg.scenes || [], p.get('scene')) || state.scene;
    if (el.scenes) [].forEach.call(el.scenes.children, function (x) {
      x.setAttribute('aria-pressed', String(state.scene && x.dataset.id === state.scene.id));
    });
    el.input.value = state.text;
    [].forEach.call(el.colors.children, function (x) { x.setAttribute('aria-pressed', String(x.dataset.id === state.color.id)); });
    [].forEach.call(el.fonts.children, function (x) { x.setAttribute('aria-pressed', String(x.dataset.id === state.font.id)); });
  })();

  update();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { update(); });
  }
  window.addEventListener('resize', function () { fitToScale(); }, { passive: true });
})();
